import React from 'react';

import { cookies as documentCookie } from '@catalogo/core-cookies';
import query from '@catalogo/core-graphql-cache/src/local/cookies/cookies.graphql';
import { useApolloClient, useQuery } from '@apollo/client';
import { useConfig } from './config';
import { useRouter } from './router';

export const withCookies = Component => {
  const InnerComponent = props => {
    const [allcookies, setCookie] = useCookies();

    return <Component {...props} cookies={allcookies} setCookie={setCookie} />;
  };

  return InnerComponent;
};
export const setCookie = (client, context, config) => (key, value, options) => {
  client.writeQuery({ query, data: { cookies: { [key]: value } } });

  const opt = {
    domain: config.cookieDomain,
    path: '/',
    ...options,
  };

  if (context) {
    context.cookies.push({ key, value, opt });
  } else {
    documentCookie.set(key, value, opt);
  }
};

export const useCookies = () => {
  const client = useApolloClient();
  const router = useRouter();
  const config = useConfig();

  const { data } = useQuery(query);

  const nickname = data?.cookies[`${config.brand}Nick`];
  const allcookies = { nickname, ...data?.cookies };
  return [allcookies, setCookie(client, router.staticContext, config)];
};

export const readCookies = client => client.readQuery({ query });
